
/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function navToggle() {
  const subMenuToggle = document.querySelectorAll(
    '.menu-item-has-children > a, .page_item_has_children > a'
  );

  [...subMenuToggle].forEach((x) => {
    x.addEventListener('click', (e) => {
      e.preventDefault();
      x.parentNode.classList.toggle('focus');
    });
  });

  document.addEventListener('click', (e) => {
    const listItems = document.querySelectorAll('.menu-item-has-children');

    if (e.target.closest('.menu-item-has-children')) {
      return;
    }
    [...listItems].forEach((elem) => {
      elem.classList.remove('focus');
    });
  });
}());
